require("!!C:\\svn\\trunk\\node_modules\\script-loader\\addScript.js")(require("!!C:\\svn\\trunk\\node_modules\\raw-loader\\index.js!C:\\svn\\trunk\\node_modules\\uglify-loader\\index.js!C:\\svn\\trunk\\node_modules\\babel-loader\\lib\\index.js?{\"presets\":[\"react\",\"es2015\"],\"plugins\":[\"transform-class-properties\",\"transform-object-assign\"],\"compact\":false}!C:\\svn\\trunk\\client-side\\Nette\\nette.ajax.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/uglify-loader!./client-side/Nette/nette.ajax.js
// module id = 132
// module chunks = 0